import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

// COMPONENTS/COMPONENTES  ------------------------------------------------
import { AdminComponent } from './admin.component';
import { HomeComponent } from './pages/home/home.component';
import { CargarIglesiasCsvComponent } from './pages/cargar-iglesias-csv/cargar-iglesias-csv.component';
import { IglesiasComponent } from './pages/iglesias/iglesias.component';
import { NuevaIglesiaComponent } from './pages/iglesias/nueva-iglesia/nueva-iglesia.component';
import { ListaIglesiasComponent } from './pages/iglesias/lista-iglesias/lista-iglesias.component';
import { VerIglesiaComponent } from './pages/iglesias/ver-iglesia/ver-iglesia.component';
import { BuscarIglesiaComponent } from './pages/iglesias/buscar-iglesia/buscar-iglesia.component';
import { MembersComponent } from './pages/members/members.component';
import { MemberListComponent } from './pages/members/member-list/member-list.component';
import { MemberDetailComponent } from './pages/members/member-detail/member-detail.component';
import { MemberDetailEditComponent } from './pages/members/member-detail-edit/member-detail-edit.component';
import { MasiveMembersLoadComponent } from './pages/masive-members-load/masive-members-load.component';
import { ExtensionComponent } from './pages/extension/extension.component';
import { PlantersListComponent } from './pages/extension/planters-list/planters-list.component';
import { SeederDashComponent } from './pages/extension/seeder-dash/seeder-dash.component';
import { PlantersReportComponent } from './pages/extension/planters-report/planters-report.component';
import { MinistersComponent } from './pages/ministers/ministers.component';
import { MinisterPostulationComponent } from './pages/ministers/minister-postulation/minister-postulation.component';
import { MinisterListComponent } from './pages/ministers/minister-list/minister-list.component';
import { PostulateMinisterComponent } from './pages/ministers/postulate-minister/postulate-minister.component';
import { VerPostulacionComponent } from './pages/ministers/ver-postulacion/ver-postulacion.component';
import { MapaIglesiasComponent } from './pages/iglesias/mapa-iglesias/mapa-iglesias.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';
import { IglesiasPendientesComponent } from './pages/iglesias/iglesias-pendientes/iglesias-pendientes.component';
import { NewChurchComponent } from './pages/iglesias/new-church/new-church.component';
import { RolesComponent } from './pages/roles/roles.component';
import { ListRolesComponent } from './pages/roles/list-roles/list-roles.component';
import { RequestsCredentialRenovationComponent } from './pages/ministers/requests-credential-renovation/requests-credential-renovation.component';
import { SeeCredentialRenovationComponent } from './pages/ministers/see-credential-renovation/see-credential-renovation.component';
import { MembersListComponent } from './pages/iglesias/members-list/members-list.component';

const routes: Routes = [
    {
        path: '',
        component: AdminComponent,

        children: [
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full',

            },
            {
                path: 'home',
                component: HomeComponent
            },
            {
                path: 'iglesias',
                component: IglesiasComponent,
                children: [
                    { path: 'lista', component: ListaIglesiasComponent },
                    { path: 'editar/:id', component: NewChurchComponent },
                    { path: 'members/:id', component: MembersListComponent },
                    { path: 'nueva-iglesia', component: NuevaIglesiaComponent },
                    { path: 'ver/:id', },
                    {
                        path: 'buscar-iglesia',
                        component: BuscarIglesiaComponent,
                        runGuardsAndResolvers: 'always'
                    },
                    { path: 'mapa', component: MapaIglesiasComponent },
                    { path: 'pendientes', component: IglesiasPendientesComponent },
                    { path: '', pathMatch: 'full', redirectTo: 'lista' },
                    { path: '**', pathMatch: 'full', redirectTo: 'lista' }
                ]
            },
            {
                path: 'iglesia/ver/:id',       // SE IMPLEMENTA ESTA RUTA ALTERNATIVA DADO EL CAMBIO DE LA INTERFAZ GRAFICA
                component: VerIglesiaComponent // PARA NO REPERCUTIR EN GRAN MEDIDA AL CODIGO FUENTE
            },
            {
                path: 'cargar-iglesias-csv',
                component: CargarIglesiasCsvComponent
            },
            {
                path: 'members',
                component: MembersComponent,
                children: [
                    { path: 'list', component: MemberListComponent },
                    { path: 'detail/:id', component: MemberDetailComponent, },
                    { path: 'detail/edit/:id', component: MemberDetailEditComponent },
                    { path: 'masive-members-load', component: MasiveMembersLoadComponent },
                    { path: '', pathMatch: 'full', redirectTo: 'list' },
                    { path: '**', pathMatch: 'full', redirectTo: 'list' }
                ]
            },
            {
                path: 'extension',
                component: ExtensionComponent,
                children: [
                    { path: 'planter-list', component: PlantersListComponent },
                    { path: 'planters-report', component: PlantersReportComponent },
                    { path: 'seeder-dash', component: SeederDashComponent },
                    { path: '', pathMatch: 'full', redirectTo: 'planter-list' },
                    { path: '**', pathMatch: 'full', redirectTo: 'planter-list' }
                ]
            },
            {
                path: 'ministers',
                component: MinistersComponent,
                children: [
                    {
                        path: 'minister-postulation/:id',
                        component: MinisterPostulationComponent
                    },
                    { path: 'ver-postulacion/:id', component: VerPostulacionComponent },
                    { path: 'postulate', component: PostulateMinisterComponent },
                    { path: 'minister-list', component: MinisterListComponent },
                    { path: 'request-credential-renovation', component: RequestsCredentialRenovationComponent },
                    { path: 'request-credential-renovation/:id', component: SeeCredentialRenovationComponent },
                    { path: '', pathMatch: 'full', redirectTo: 'minister-list' },
                    { path: '**', pathMatch: 'full', redirectTo: 'minister-list' }
                ]
            },
            {
                path: 'roles',
                component: RolesComponent,
                children: [
                    { path: 'roles-list', component: ListRolesComponent },
                    { path: '', pathMatch: 'full', redirectTo: 'roles-list' },
                    { path: '**', pathMatch: 'full', redirectTo: 'roles-list' }
                ]
            },
            {
                path: 'notifications',
                component: NotificationsComponent
            }
        ]
    },
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/admin/admin-routing.module.ts